// modules
import { createAction } from 'redux-actions'

// actions
export const setMedicalDeviceManagementList = createAction(
  'SET_MEDICAL_DEVICE_MANAGEMENT_LIST'
)

export const resetMedicalDeviceManagement = createAction(
  'RESET_MEDICAL_DEVICE_MANAGEMENT'
)
